import List from '@mui/material/List';
import {type NotificationDto} from '@onroadvantage/optix-safeandsound-openapi';

import {NotificationListItem} from './NotificationListItem';

interface NotificationListProps {
  notifications: NotificationDto[];
  onNotificationClick: (notification: NotificationDto) => void;
  onArchive: (id: string) => void;
}

export function NotificationList({
  notifications,
  onNotificationClick,
  onArchive,
}: NotificationListProps): JSX.Element {
  return (
    <List disablePadding sx={{maxHeight: 400, overflowY: 'auto'}}>
      {notifications.map((notification) => (
        <NotificationListItem
          key={notification.id}
          notification={notification}
          onClick={onNotificationClick}
          onArchive={onArchive}
        />
      ))}
    </List>
  );
}
